import { RowNode } from '@ag-grid-community/core'
import { Component, ElementRef, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { TransactionConstants } from '../../../..//util/constants'
import { Security } from '../../../../model/security.model'
import {
  ExternalDataSourceTypeId,
  ExternalDataSourceTypeName,
} from '../../../../model/single-transaction/external-unmatched-transaction'
import { Calculators } from '../../../../util/calculators.util'
import { setHighestZIndexForOpenModals } from '../../../../util/common-utils'

@Component({
  selector: 'hs-calculate-price',
  templateUrl: './calculate-price.component.html',
  styleUrls: ['./calculate-price.component.scss'],
})
export class CalculatePriceComponent implements OnInit {
  @Input() rowNodeMap?: Map<string, RowNode>
  @Input() security?: Security

  readonly title = 'Calculated Price'
  readonly compId = TransactionConstants.TRADE_CALC_COMP_ID

  radioSource: FormControl = new FormControl('1')
  selectedOption: ExternalDataSourceTypeName = 'Custody'
  price = 0.0

  constructor(
    readonly activeModal: NgbActiveModal,
    readonly eleRef: ElementRef,
  ) {}

  ngOnInit() {
    setHighestZIndexForOpenModals(this.compId, this.eleRef)
    this.calculatedPrice(ExternalDataSourceTypeId.Custody)
    this.radioSource.valueChanges
      .pipe()
      .subscribe((newVal: ExternalDataSourceTypeId) => {
        this.onExternalDataSourceChanged(newVal)
      })
  }

  onExternalDataSourceChanged(source: ExternalDataSourceTypeId) {
    this.selectedOption =
      source == ExternalDataSourceTypeId.Custody ? 'Custody' : 'Trading'
    this.calculatedPrice(source)
  }

  calculatedPrice(source: ExternalDataSourceTypeId) {
    if (this.security) {
      const proceeds =
        source == ExternalDataSourceTypeId.Custody
          ? Number(this.rowNodeMap?.get('proceeds')?.data.custody)
          : Number(this.rowNodeMap?.get('proceeds')?.data.trading)
      if (!proceeds) {
        this.price = 0.0
        return
      }
      const units = Number(this.rowNodeMap?.get('units')?.data.value)
      const factor = Number(this.rowNodeMap?.get('factor')?.data.value)
      const commission = Number(this.rowNodeMap?.get('commission')?.data.value)

      const accrued = Number(this.rowNodeMap?.get('decimalAccrued')?.data.value)

      if (units && factor)
        this.price = Calculators.calculatePriceForProceedMatch(
          accrued,
          units,
          factor,
          commission,
          this.security,
          proceeds,
        )
    }
  }

  usePrice() {
    this.rowNodeMap?.get('price')?.setDataValue('value', this.price)
    this.activeModal.close()
  }

  getComponentId() {
    return this.compId
  }
}
